import { reset } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../index';

const defaultInitialState = {
	isShow: false,
	initialValues: null
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-form`;
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		transferFormSubmit: formData => (dispatch, getState) => {
			let data = cloneDeep(formData);
			data.amount = data.amount && data.amount.replace(/ /g, '');
			data.purseFrom = data.purseFrom[0].value;

			const request = http({
				url: endpoints.WM.TRANSFER,
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data
			});

			return request(dispatch).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					dispatch(parentActions.fetchData(null, data.purseFrom));
				}

				if (action.type === FORM_SUBMIT_ERROR) {
					alert(action.payload.response.data);
				}
			});
		},

		toggleTransferForm: initValues => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM, payload: {data: initValues} });
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_FORM]: (state, action) => {
			return ({
				...state,
				transferForm: {
					initialValues: state.transferForm.isShow ? null : (action.payload.data || null),
					isShow: !state.transferForm.isShow
				}
			});
		},

		[FORM_SUBMIT_SUCCESS]: state => ({
			...state,
			transferForm: {
				...state.transferForm,
				isShow: false
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			const initialValues = state[`${namespace}`].transferForm.initialValues;
			const defaultPurse = state[`${namespace}`].data && state[`${namespace}`].data.purse;
			const builtPurse = defaultPurse ?
				[{value: defaultPurse.pursename, label: `${defaultPurse.pursename} (${defaultPurse.amount})`}] :
				null;
			return {
				...initialValues,
				purseFrom: builtPurse
			};
		},
		getShouldShowTransferForm: state => state[`${namespace}`].transferForm.isShow
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/transfer-form/index.js